import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ExtendedBaseTab } from '@common/classes/extended-base-tab';
import { VesselVisitService } from '@common/services/vessel-visit.service';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { CustomExtendedTabService } from 'app/singleton-services/custom-extended-tab.service';
import { DisplayDiscrepanciesService } from 'app/singleton-services/display-discrepancies.service';
@Component({
    selector: 'app-vessel-visit-service-requests-modal',
    templateUrl: './vessel-visit-service-requests-modal.component.html',
    styleUrls: ['./vessel-visit-service-requests-modal.component.css'],
    standalone: false
})
export class VesselVisitServiceRequestsModalComponent extends ExtendedBaseTab implements OnInit, OnChanges {
    vesselVisitId: number;
    cargoManifestId: number;
    serviceRequests: any[] = [];
    isBusy = false;

    constructor(
        public activeModal: DialogRef,
        public customExtendedTabService: CustomExtendedTabService,
        private router: Router,
        private vesselVisitService: VesselVisitService,
        private displayDiscrepanciesService: DisplayDiscrepanciesService
    ) {
        super(customExtendedTabService);
    }

    get displayDiscrepancies(): boolean {
        return this.displayDiscrepanciesService.displayDiscrepancies;
    }

    ngOnInit() {
        this.isBusy = true;
        this.defaultPaging();
        if (this.serviceRequests) {
            this.getVesselVisitServiceRequests(this.vesselVisitId, this.cargoManifestId);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.serviceRequests && !changes.serviceRequests.firstChange) {
            this.loadItems(this.serviceRequests);
        }
    }

    getClass(status): string {
        return this.resolveStatusPillClass(status);
    }

    navigateToServiceRequest(srId: number) {
        this.activeModal.close();
        this.router.navigate(['/tos-operations/service-request/edit', srId]);
    }

    private getVesselVisitServiceRequests(vesselVisitId: number, cargoManifestId: number) {
        this.vesselVisitService
            .getServiceRequestsForVesselVisit({ vesselVisitId: vesselVisitId, cargoManifestId: cargoManifestId })
            .subscribe((response) => {
                this.serviceRequests = response;
                this.loadItems(this.serviceRequests);
                this.isBusy = false;
            });
    }
}
